import '../../../stylesheets/media_selection.scss';
import AppLoading, {AppLoadError} from '../app_loading';
import React from "react"
import {photographerUploadTarget, customerMediaTarget, productionMediaTarget} from '../../util/dashboard_role';
import {withRouter} from "react-router-dom"
import UploadPhotosModal from "./upload_photos_modal_container"
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import GalleryModal from "../gallery/gallery_modal"
import video from "../../../../assets/images/icons/service/VideoService.svg"
import arrowDownSrc from "../../../../assets/images/icons/blue-arrow-down.svg"
import mediaDownloadIconSrc from '../../../../assets/images/icons/media-download-icon.svg'
import {ReactComponent as DownloadIcon} from '../../../../assets/images/icons/download.svg'
import {
  deleteMedia,
  fetchBinaryData,
  fetchFloorPlanLabels,
  fetchProjectMedias,
  updateProjectDetails,
  uploadPhotos
} from "../../util/project_api_util"
import DownloadModal from "./download_modal_container";
import { serviceIcon } from "../../util/service_util";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner.gif";
import { InView } from 'react-intersection-observer';
import {downloadMediaFolder} from "../../util/file_utils";
import ShareMediaModal from "./share_media_modal_container"
import FloorPlanLabelsModal from "./floor_plan_labels_modal"
import { stripFileExtension } from "../../util/easy_format_utils"

// The media payload is keyed by attachment id, so Object.values returns id
// order. Floor plans follow their saved sort_order (kept stable by room-name
// edits) so swapped files stay in place: floor 1, 2, 3, all floors, PDF.
const orderFloorPlans = (medias, serviceId, project) => {
  const service = (project?.services || []).find(s => String(s.id) === String(serviceId))
  if (service?.title !== "Floor Plans") return medias
  return [...medias].sort((a, b) => ((a.sort_order ?? 0) - (b.sort_order ?? 0)) || (a.id - b.id))
}

class EditProjectMedia extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      photoSelection: false,
      streamAmount: this.props.isLargeScreen ? 12 : 8,
      selectedMedia: {},
      modalOpen: false,
      galleryModal: false,
      virtualStagingGalleryModal: false,
      shareMediaModal: false,
      virtualStagingPhoto: {},
      downloadModal: false,
      manualUpload: false,
      currentPhoto: 0,
      unprocessed: this.props.currentUser?.roles?.admin || this.props.currentUser?.roles?.post_production || this.props.currentUser?.roles?.contractor || (this.props.project?.upload_key && this.props.project?.upload_key === this.props.match.params.accessCode) ? true : false,
      copied: {},
      copiedLink: false,
      copiedSnippet: false,
      selectedServiceIndex: 0,
      upload_link: this.props.project?.external_model_id,
      processedMedias: Object.values(this.props.project?.processed_medias || {}),
      unprocessedMedias: Object.values(this.props.project?.unprocessed_medias || {}),
      unprocessed_zip_worker_file: this.props.project?.unprocessed_zip_worker_file,
      processed_zip_worker_file: this.props.project?.processed_zip_worker_file,
      uploadDisabled: true,
      success_message: "",
      download_pending: false,
      loading: !!this.props.project?.services?.length,
      loadError: false,
      swapStatus: {},
      saveMediaPending: {},
    }
    this.handler = this.handler.bind(this)
    this.onDeleteMedia = this.onDeleteMedia.bind(this)
    this.downloadMedia = this.downloadMedia.bind(this)
    this.downloadVirtualMedia = this.downloadVirtualMedia.bind(this)
    this.getDownloadInfo = this.getDownloadInfo.bind(this)
    this.selectAllMedia = this.selectAllMedia.bind(this)
    this.enableSelection = this.enableSelection.bind(this)
    this.disableSelection = this.disableSelection.bind(this)
    this.clearSelection = this.clearSelection.bind(this)
    this.openUploadModal = this.openUploadModal.bind(this)
    this.selectMedia = this.selectMedia.bind(this)
    this.copyEmbeddedCode = this.copyEmbeddedCode.bind(this)
    this.downloadPhoto = this.downloadPhoto.bind(this)
    this.onClose = this.onClose.bind(this)
    this.submitMatterport = this.submitMatterport.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.copyLink = this.copyLink.bind(this)
    this.copySnippet = this.copySnippet.bind(this)
    this.openInNewTab = this.openInNewTab.bind(this)
    this.downloadAll = this.downloadAll.bind(this)
    this.reloadProjectMedias = this.reloadProjectMedias.bind(this)
    this.swapProductionStatus = this.swapProductionStatus.bind(this)
    this.changeVideoState = this.changeVideoState.bind(this)
    this.videoRef = React.createRef()
    this.openVirtualStagingGallery = this.openVirtualStagingGallery.bind(this)
    this.submitPhotosFromUploadModal = this.submitPhotosFromUploadModal.bind(this)
    this._mediaRequestId = 0
  }

  componentDidMount() {
    if (this.applyRequestedUploadService()) return;
    const service = this.services()[this.state.selectedServiceIndex];
    if (service) return this.reloadProjectMedias(service.id);
    this.setState({loading: false});
  }

  // After a room-name edit: refresh the plans now, then keep checking (quietly)
  // until the new ZIP is ready so Download enables without a page refresh.
  watchFloorPlanZip = (serviceId, attempt = 0, tab = this.state.selectedServiceIndex) => {
    clearTimeout(this._floorPlanZipTimer)
    // Stop if the user left the page or switched to another service tab.
    if (this._mediaUnmounted || this.state.selectedServiceIndex !== tab || this.state.unprocessed) return this.setState({floorPlanZipPending: false})
    if (attempt === 0) this.setState({floorPlanZipPending: true, processed_zip_worker_file: null})
    Promise.resolve(this.reloadProjectMedias(serviceId, null, attempt > 0)).then(() => {
      if (this._mediaUnmounted) return
      if (this.state.processed_zip_worker_file || attempt >= 36) return this.setState({floorPlanZipPending: false})
      this._floorPlanZipTimer = setTimeout(() => this.watchFloorPlanZip(serviceId, attempt + 1, tab), 5000)
    }).catch(() => {})
  }

  openFloorPlanLabels = () => {
    if (this.state.floorPlanLabelsLoading) return
    this.setState({floorPlanLabelsLoading: true})
    fetchFloorPlanLabels(this.props.project.id)
      .then(data => this.setState({floorPlanLabelsLoading: false, floorPlanLabelsData: data, floorPlanLabelsModal: true}))
      .fail(xhr => {
        this.setState({floorPlanLabelsLoading: false})
        this.props.showToast?.(xhr?.responseJSON?.error || "Room names could not be loaded. Please try again.")
      })
  }

  componentWillUnmount() {
    clearTimeout(this._floorPlanZipTimer)
    this._mediaUnmounted = true;
    this._mediaRequestId += 1;
  }

  applyRequestedUploadService() {
    if (this._requestedUploadApplied) return false;
    const uploadTarget = photographerUploadTarget(this.props.currentUser, this.props.project, this.props.location?.search);
    const productionTarget = productionMediaTarget(this.props.currentUser, this.props.project, this.props.location?.search);
    const target = uploadTarget || productionTarget || customerMediaTarget(this.props.currentUser, this.props.project, this.props.location?.search);
    if (!target) return false;
    this._requestedUploadApplied = true;
    this.setState({selectedServiceIndex: target.index, unprocessed: !!uploadTarget || !!productionTarget?.unprocessed}, () => {
      this.reloadProjectMedias(target.serviceId).then(() => {
        if (!this._mediaUnmounted) document.getElementById('project-media')?.scrollIntoView({block: 'start'});
      }).catch(() => {
        if (!this._mediaUnmounted) {
          this.setState({selectedServiceIndex: 0, loading: false});
          this.props.showToast?.('Could not load the media area. Please refresh and try again.');
        }
      });
    });
    return true;
  }

  componentDidUpdate(prevProps, prevState){
    if (!this.props.project) return;
    if (this.applyRequestedUploadService()) return;
    if (this.props.project?.id && prevProps.project?.id !== this.props.project.id) {
      this.setState({photoSelection: false, selectedMedia: {}});
      const service = this.services()[this.state.selectedServiceIndex];
      if (service) return this.reloadProjectMedias(service.id);
    }
    if (prevProps?.project?.current_service?.id != this.props?.project?.current_service?.id){
      this.setState({photoSelection: false, selectedMedia: {}});
      this.reloadProjectMedias(this.props.project?.current_service?.id)
    }
  }

  handler(newState) {
    this.setState(newState)
  }

  changeVideoState(inView) {
    if (inView) {
      this.videoRef.current.play();
    } else {
      this.videoRef.current.pause();
    }
  }

  reloadProjectMedias(serviceId, ignore_variants = null, quiet = false) {
    const projectId = this.props.project.id
    const access_code = this.props.match.params?.accessCode
    const media_code = this.props.match.params?.shareCode

    this._mediaRequestId += 1
    const requestId = this._mediaRequestId

    if (!quiet) this.setState({loading: true, loadError:false})

    return fetchProjectMedias(projectId, serviceId, media_code, access_code, ignore_variants).then((response) => {
      if (this._mediaUnmounted || requestId !== this._mediaRequestId) return

      const projectMedias = Object.values(response)[0]

      this.setState({
        processedMedias: orderFloorPlans(Object.values(projectMedias.processed_medias || {}), serviceId, this.props.project),
        unprocessedMedias: Object.values(projectMedias.unprocessed_medias || {}),
        unprocessed_zip_worker_file: projectMedias.unprocessed_zip_worker_file,
        processed_zip_worker_file: projectMedias.processed_zip_worker_file,
        floorPlanLabelsEditable: !!projectMedias.floor_plan_labels_editable,
        loading: false
      });
    }).catch(() => {
      if (!this._mediaUnmounted && requestId === this._mediaRequestId) this.setState({loading:false, loadError:true});
    })
  }

  swapCubicasa(package_id, cubicasa){
    let data = {id: this.props.project.id, project: {id: this.props.project.id, packages_attributes: {cubicasa: cubicasa, id: package_id}}}
    updateProjectDetails(data).then(() => this.props.reloadProject())
  }

  swapSaveMedia(package_id, save_media){
    this.setState(prev => ({ saveMediaPending: { ...prev.saveMediaPending, [package_id]: save_media } }))
    let data = {id: this.props.project.id, project: {id: this.props.project.id, packages_attributes: {save_media: save_media, id: package_id}}}
    updateProjectDetails(data).then(() => {
      this.props.reloadProject()
      this.setState(prev => {
        const next = { ...prev.saveMediaPending }
        delete next[package_id]
        return { saveMediaPending: next }
      })
      if (this.props.showToast) this.props.showToast(save_media ? "Save Media turned on" : "Save Media turned off")
    })
  }

  swapProductionStatus(current_package, production_downloaded){
    if(Object.values(this.state.swapStatus).length === 0){
      let new_package = current_package
      new_package["production_downloaded"] = production_downloaded
      let data = { id: this.props.project.id, project: { id: this.props.project.id, packages_attributes: [new_package] } }
      let oldSwapStatus = JSON.parse(JSON.stringify(this.state.swapStatus))
      let newSwapStatus = JSON.parse(JSON.stringify(this.state.swapStatus))
      newSwapStatus[current_package.service_id] = production_downloaded
      if (oldSwapStatus[current_package.service_id]){
        delete oldSwapStatus[current_package.service_id]
      }
      this.setState({swapStatus: newSwapStatus})
      updateProjectDetails(data).then(() => this.props.reloadProject()).then(() => this.setState({swapStatus: oldSwapStatus}))
    } else {
      this.props.showToast("Star change being processed")
    }
  }

  copyEmbeddedCode(media_url) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(`<video controls style="width: 100%; max-width: 800px; height: auto;">
            <source src=${media_url} type='video/mp4' />
       </video>`)
    } else {
      navigator.clipboard.writeText(
        `<video controls style="width: 100%; max-width: 800px; height: auto;">
            <source src=${media_url} type='video/mp4' />
       </video>`
      )
    }
    this.props.showToast("Embedded link copied")
    // this.setState({copied: {[media_url]: true}})
  }

  copyMLSCode(media_id, slug) {
    // Construct the tour link with 'tour' subdomain
    const hostname = window.location.host;
    const protocol = window.location.protocol;

    // Remove 'www' if it exists in the hostname
    const baseHost = hostname.startsWith('www.') ? hostname.slice(4) : hostname;
    const tourBaseUrl = `${protocol}//tour.${baseHost}`;
    const tourLink = `${tourBaseUrl}/${slug}/${media_id}`;

    // Copy the link to the clipboard
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(tourLink);
    } else {
      navigator.clipboard.writeText(tourLink);
    }

    // Show a toast notification
    this.props.showToast("MLS link copied");
  }

  copyLink(text){
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text)
    } else {
      navigator.clipboard.writeText(text
      )
    }
    // this.setState({ copiedLink: true })
    this.props.showToast("Link copied")
  }

  copySnippet(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text)
    } else {
      navigator.clipboard.writeText(text
      )
    }

    this.props.showToast("Link copied")
    // this.setState({ copiedSnippet: true })
  }

  onClose(){
    this.setState({downloadModal: false})
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea")
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    document.execCommand('copy')

    document.body.removeChild(textArea)
  }

  onInputChange(field) {
    return (e) => {
      e.preventDefault()
      this.setState({ [field]: e.target.value })
    }
  }

  submitMatterport() {
    if (this.state.upload_link !== this.props.project.external_model_id){
      const { selectedServiceIndex } = this.state
      const services = this.services()
      const selectedService = services[selectedServiceIndex]
      const selectedServiceId = selectedService?.id
      const access_code = this.props.match.params?.accessCode

      let data = { id: this.props.project.id, access_code: access_code, project: { id: this.props.project.id, external_model_id: this.state.upload_link } }

      // let formData = new FormData()
      // formData.append("project[external_model_id]", this.state.upload_link)
      // formData.append("id", this.props.project.id)
      // formData.append("access_code", access_code)

      updateProjectDetails(data, this.props.project.id).then(() => {
        this.setState({ success_message: "", uploadDisabled: true })
        this.props.reloadProject(selectedServiceId)
      })
    }
  }


  currentTabMedias() {
    return this.state.unprocessed ? this.state.unprocessedMedias : this.state.processedMedias;
  }

  getDownloadInfo() {
    const medias = this.currentTabMedias();
    const selected = medias.filter(media => this.state.selectedMedia[media.id]);
    if (!selected.length) return this.props.showToast("No media selected");
    if (this.state.download_pending) return this.props.showToast("Your download is already being prepared");
    if (selected.length === medias.length) return this.downloadAll();
    const roles = this.props.currentUser?.roles || {};
    if ((roles.client || roles.broker || roles.sub_broker) && selected.length > 10) {
      return this.props.showToast("Choose up to 10 photos, or select all to download the full ZIP");
    }
    this.setState({download_pending: true});
    this.props.showToast("Preparing your selected media ZIP. Your download will start shortly.");
    const accessCode = this.props.match.params?.accessCode;
    return Promise.resolve(fetchBinaryData(selected.map(media => media.id), this.props.project.id, accessCode))
      .then(medias => this.downloadMedia(medias))
      .catch(() => {
        if (!this._mediaUnmounted) this.props.showToast("Could not prepare your download. Please try again.");
      }).finally(() => {
        if (!this._mediaUnmounted) this.setState({download_pending: false});
      });
  }

  openInNewTab(url) {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  downloadAll(){
    const zip = this.state.unprocessed ? this.state.unprocessed_zip_worker_file : this.state.processed_zip_worker_file;
    if (!zip || (this.state.floorPlanZipPending && !this.state.unprocessed && this.selectedService()?.title === 'Floor Plans')) {
      return this.props.showToast("The full media ZIP is still being prepared. Please try again shortly.");
    }
    this.openInNewTab(zip);
    this.props.showToast("Your media ZIP is downloading. Check your browser's downloads.");
  }

  downloadMedia(medias, photo = null, virtual_staging_purchase = null) {
    return downloadMediaFolder(medias, this.props.project.address.street1, photo, virtual_staging_purchase);
  }

  downloadPhoto(e, photo, virtual_staging_purchase = null) {
    e.preventDefault()
    const access_code = this.props.match.params?.accessCode
    fetchBinaryData([photo.media_id], this.props.project.id, access_code).then(medias => {
      this.downloadMedia(medias, photo, virtual_staging_purchase)
    })
  }

  downloadVirtualMedia(medias, product) {
    const zip = new JSZip()

    const img = zip.folder(this.props.project.address.street1)

    Object.values(medias).forEach((media, i) => {
      let file_extention = media[1].split("/")[1]
      if (file_extention === "x-nikon-nef") {
        file_extention = "NEF"
      }
      img.file(`${product}_${i + 1}.${file_extention}`, media[0], {base64: true})
    })

    zip.generateAsync({type: "blob"}).then(function (content) {
      FileSaver.saveAs(content, "modern_angles_media.zip")
    })
  }

  selectService(e, i) {
    e.preventDefault()

    const services = this.services()

    if (i === this.state.selectedServiceIndex) return
    this.setState({selectedServiceIndex: i, loading: true, loadError:false, photoSelection: false, selectedMedia: {}})
    this.reloadProjectMedias(services[i].id)
  }

  onDeleteMedia() {
    if (Object.values(this.state.selectedMedia).length === 0){
      this.props.showToast("No photos selected")
    } else {
      if (!window.confirm('Are you sure you want to delete these photos?')) return
      const media_ids = Object.values(this.state.selectedMedia).map(media => media.id)
      const {selectedServiceIndex} = this.state
      const packages = Object.values(this.props.project.packages || [])
      let services = this.props.currentUser?.roles?.contractor ?
        this.props.project.services.filter(s => {
          return packages.find(p => p.contractor_id === this.props.currentUser?.id && p.service_id === s.id)
        }) :
        this.props.project.services

      if (this.props.currentUser?.roles?.post_production || (this.props.project.upload_key && this.props.match.params.accessCode === this.props.project.upload_key)) {
        services = this.props.project.services.filter(s => {
          return packages.find(p => !(p.service_title === "Floor Plans" && p.cubicasa) && s.media_types !== "matterport" && p.service_id === s.id)
        })
      }

      const selectedService = services[selectedServiceIndex]
      const selectedServiceId = selectedService?.id
      const access_code = this.props.match.params?.accessCode

      deleteMedia(media_ids, access_code, this.props.project.id).then((result) => {
        this.reloadProjectMedias(selectedServiceId).then(() => {
          this.setState({selectedMedia: {}})
        })

        if (result.notice){
          this.props.showToast(result.notice)
        }
      })
    }
  }

  selectMedia(media, i) {
    if (this.state.photoSelection) {
      let medias = Object.assign({}, this.state.selectedMedia)

      if (medias[media.id]) {
        delete medias[media.id]
      } else {
        medias[media.id] = media
      }

      this.setState({selectedMedia: medias})
    } else {
      this.setState({galleryModal: true, currentPhoto: i})
    }
  }

  openVirtualStagingGallery(media){
    this.setState({virtualStagingGalleryModal: true, virtualStagingPhoto: media.url})
  }

  selectAllMedia(medias) {
    this.setState({selectedMedia: Object.fromEntries(medias.map(media => [media.id, media]))});
  }

  selectionCheckbox(media) {
    if (!this.state.photoSelection) return null;
    return <label className="mediaSelectionCheckbox" onClick={e => e.stopPropagation()}>
      <input type="checkbox" checked={!!this.state.selectedMedia[media.id]}
        aria-label={`Select ${media.file_name || 'media'}`} onChange={() => this.selectMedia(media)}/>
      <span aria-hidden="true">&#10003;</span>
    </label>;
  }

  openUploadModal(e) {
    e.preventDefault()
    this.setState({modalOpen: true})
  }

  enableSelection(e) {
    e.preventDefault()
    this.setState({photoSelection: true})
  }

  disableSelection(e) {
    e.preventDefault()
    this.setState({photoSelection: false, selectedMedia: {}})
  }

  clearSelection(e) {
    e.preventDefault()
    this.setState({selectedMedia: {}})
  }

  submitMatterportFromUploadModal(link) {
    const access_code = this.props.match.params?.accessCode
    const selectedService = this.selectedService()

    let data = {
      id: this.props.project.id,
      access_code: access_code,
      project: { id: this.props.project.id, external_model_id: link } }

    updateProjectDetails(data, this.props.project.id).then(() => {
      this.setState({modalOpen: false})
      this.reloadProjectMedias(selectedService?.id)
    })
  }

  submitPhotosFromUploadModal(project, service, unprocessed, medias) {
    const access_code = this.props.match.params?.accessCode
    const formData = new FormData()

    formData.append("media_upload[project_id]", project.id)
    formData.append("media_upload[service_id]", service.id)

    if (this.props.currentUser?.roles?.admin && unprocessed) {
      let selected_package = Object.values(project.packages).find((current_package) => current_package.service_id === service.id)
      formData.append("media_upload[uploading_user_id]", selected_package?.contractor_id || this.props.currentUser?.id)
    } else if (!this.props.currentUser && access_code === project.upload_key){
      formData.append("media_upload[uploading_user_id]", project.post_production_user_id)
    } else {
      formData.append("media_upload[uploading_user_id]", this.props.currentUser?.id)
    }

    for (let i = 0; i < medias.length; i++) {
      formData.append("media_upload[medias][]", medias[i])
    }

    formData.append("access_code", access_code)

    return uploadPhotos(formData).then((result) => {
      this.reloadProjectMedias(service.id, true)
      return result
    })
  }

  services() {
    if (!this.props.project) return [];
    const packages = Object.values(this.props.project.packages || [])

    let services = this.props.currentUser?.roles?.contractor ?
      this.props.project.services.filter(s => {
        return packages.find(p => p.contractor_id === this.props.currentUser?.id && p.service_id === s.id)
      }) :
      this.props.project.services

    if (this.props.currentUser?.roles?.post_production || (this.props.project.upload_key && this.props.match.params.accessCode === this.props.project.upload_key)) {
      services = this.props.project.services.filter(s => {
        return packages.find(p => !(p.service_title === "Floor Plans" && p.cubicasa) && s.media_types !== "matterport" && p.service_id === s.id)
      })
    }

    return services
  }
  selectedService() {
    return this.services()[this.state.selectedServiceIndex]
  }

  render() {
    if (!this.props.project) return <AppLoading label="Loading media…" variant="media"/>;
    const {selectedServiceIndex, unprocessed} = this.state
    const packages = Object.values(this.props.project?.packages || [])
    const project_services = this.props.project?.services || []
    let services = this.props.currentUser?.roles?.contractor ?
      project_services.filter(s => {
        return packages.find(p => p.contractor_id === this.props.currentUser?.id && p.service_id === s.id)
      }) :
      project_services

    if (this.props.currentUser?.roles?.post_production || (this.props.project?.upload_key && this.props.match.params.accessCode === this.props.project?.upload_key)) {
      services = project_services.filter(s => {
        return packages.find(p => !(p.service_title === "Floor Plans" && p.cubicasa) && s.media_types != "matterport" && p.service_id === s.id)
      })
    }

    const {currentUser, project} = this.props
    const selectedService = services[selectedServiceIndex]
    const selectedServiceId = selectedService?.id
    const selected_package = packages.find(p => p.service_id === selectedServiceId)

    let modal = ""
    let projectEditPhotosUlId = ""
    let projectEditUl = ""
    let selectionButtons = ""

    let medias = unprocessed ?
      this.state.unprocessedMedias :
      this.state.processedMedias

    let photos = 0;

    const canUpload = (currentUser?.roles?.admin || ((currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key)) && !unprocessed) ||
      (currentUser?.roles?.contractor && unprocessed)) && !(selectedService?.title === "Virtual Staging" && unprocessed)

    const canDelete = currentUser?.roles?.admin || ((currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key)) && !unprocessed) ||
      currentUser?.roles?.contractor

    const canSelect = medias.length > 0 && (selectedService?.media_types === "image" || selectedService?.media_types === "video") && (currentUser || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key))
    const isAdmin = (currentUser?.roles?.admin || currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key))
    const isClient = (currentUser?.id === project?.client?.id)
    const isClientsBroker = (currentUser?.roles?.broker && currentUser?.firm?.id === project?.client?.firm?.id)

    const selectedCount = medias.filter(media => this.state.selectedMedia[media.id]).length;
    if (!this.state.photoSelection && canSelect) {
      selectionButtons = <div className="projectEditPhotosButtons mediaSelectionToolbar">
        <button type="button" onClick={this.enableSelection}>Select Media to Download</button>
      </div>;
    } else if (canSelect) {
      selectionButtons = <div className="projectEditPhotosButtons mediaSelectionToolbar is-selecting">
        <span className="mediaSelectionCount" role="status">{selectedCount} selected</span>
        <button type="button" onClick={() => this.selectAllMedia(medias)}>Select All</button>
        <button type="button" disabled={!selectedCount} onClick={this.clearSelection}>Clear</button>
        {selectedService?.media_types !== "video" && <button type="button" className="mediaSelectionDownload"
          disabled={!selectedCount || this.state.download_pending} onClick={this.getDownloadInfo}>
          {this.state.download_pending ? 'Preparing ZIP…' : `Download (${selectedCount})`}
        </button>}
        {canDelete && <button type="button" className="mediaSelectionDelete" disabled={!selectedCount} onClick={this.onDeleteMedia}>Delete</button>}
        <button type="button" onClick={this.disableSelection}>Cancel</button>
      </div>;
    }

    if (selectedService?.media_types === "image") {
      if (selectedService?.title === "Virtual Staging" && ((currentUser?.roles?.admin || currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key)) && unprocessed)) {
        projectEditUl = Object.values(project?.virtual_staging_purchases || [])
          .sort((a, b) => {
            if (a.status === 'complete' && b.status !== 'complete') return 1;
            if (a.status !== 'complete' && b.status === 'complete') return -1;
            return 0;
          }).map((virtual_staging_purchase, i) => {
          return Object.values(virtual_staging_purchase?.photos || []).map(photo => {
            photos += 1
            return <div className="editProjectVirtualStagingItem" key={photo.id}>
              <div className="editProjectVirtualStagingItemImage" onClick={() => this.openVirtualStagingGallery(photo)}>
                <img src={photo.url}/>
              </div>

              <div className="editProjectVirtualStagingItemDescription">
                <table>
                  <tbody>
                  <tr>
                    <td>Image:</td>
                    <td className="w-100">
                      <div className="d-flex align-items-center">
                          <a href={photo.url} target="_blank" download={photo.file_name} className="text-truncate tuncated-text">
                          {photo.file_name}
                        </a>
                        <a href={photo.url} onClick={e => this.downloadPhoto(e, photo, virtual_staging_purchase)} className="ms-2 downloadIcon">
                          <DownloadIcon/>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Type:</td>
                    <td>{virtual_staging_purchase.virtual_suite_type?.name}</td>
                  </tr>
                  <tr>
                    <td>Category:</td>
                    <td>{virtual_staging_purchase.category?.name}</td>
                  </tr>

                  <tr>
                      {isClient || currentUser.roles.admin ? <td onClick={() => this.props.openNoteModal(virtual_staging_purchase, photo)} className="addressLink">Notes:</td> : <td>Notes:</td>}
                    <td className="virtualStagingNotes">{photo.notes || virtual_staging_purchase.notes}</td>
                  </tr>
                  <tr>
                    <td>Ordered:</td>
                    <td>{new Date(virtual_staging_purchase.created_at).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    })}</td>
                  </tr>
                  <tr>
                    <td>Status:</td>
                      <td className={virtual_staging_purchase.status === "complete" ? "virtualStagingCompleted" : "virtualStagingPending"}>{virtual_staging_purchase.status === "complete" ? "Completed" : "Requested"}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          })
        })
      } else {
        if (this.state.unprocessed){
          projectEditUl = <>
            {medias.slice(0, this.state.streamAmount).map((media, i) => {
              let text = "";
              if ([".pdf", ".PDF"].includes(media.file_name?.slice(media.file_name.length - 4, media.file_name.length))) {
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                            data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <div className="projectEditTextImage projectEditPdfPlaceholder">
                    <i className="fas fa-file-pdf"/>
                  </div>
                  <div className="filename">{media.file_name}</div>
                </div>)
              } else if (media.file_name?.slice(media.file_name.length - 4, media.file_name.length) === ".CR2" || media.file_name?.slice(media.file_name.length - 4, media.file_name.length) === ".NEF" || media.file_name?.slice(media.file_name.length - 4, media.file_name.length) === ".DNG" || media.file_name?.slice(media.file_name.length - 4, media.file_name.length) === ".ARW") {
                text = media.file_name
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                            data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <div className="projectEditTextImage">{text}</div>
                </div>)
              } else {
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                            data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <img src={media.url}/>
                  <div className="filename">{stripFileExtension(media.file_name)}</div>
                </div>)
              }
            })}
          </>
        } else {
          projectEditUl = <>
            {medias.map((media, i) => {
              let text = "";
              if ([".pdf", ".PDF"].includes(media.file_name?.slice(media.file_name.length - 4, media.file_name.length))){
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                  data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <div className="projectEditTextImage projectEditPdfPlaceholder">
                    <i className="fas fa-file-pdf"/>
                  </div>
                  <div className="filename">{media.file_name}</div>
                </div>)
              } else if ([".CR2", ".NEF", ".DNG", ".ARW"].includes(media.file_name?.slice(media.file_name.length - 4, media.file_name.length))){
                text = media.file_name
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                  data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <div className="projectEditTextImage">{text}</div>
                </div>)
              } else {
                return (<div onClick={() => this.selectMedia(media, i)} className="editProjectPhoto" key={media.id}
                  data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                  <img src={media.url} />
                  <div className="filename">{stripFileExtension(media.file_name)}</div>
                </div>)
              }
            })}
          </>
        }
      }
    } else if (selectedService?.media_types === "video") {
      if (this.props.currentUser?.roles?.contractor || ((currentUser?.roles?.admin || currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key)) && unprocessed)) {
        projectEditUl = <>
          {medias.slice(0, this.state.streamAmount).map((media, i) => {
            return (
              <div onClick={() => this.state.photoSelection ? this.selectMedia(media, i) : ""} className="editProjectPhoto editProjectVideo" key={media.id}
                   data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                <video controls id={this.state.photoSelection ? "disabledVideo" : ""}>
                  <source src={`${media.url}#t=5`} type="video/mp4"/>
                </video>
                <div className="filename">{stripFileExtension(media.file_name)}</div>
              </div>
            )
          })}
        </>
      } else {
        projectEditUl = <>
          {medias.slice(0, this.state.streamAmount).map((media, i) => {
            return (
              <div onClick={() => this.state.photoSelection ? this.selectMedia(media, i) : ""} className="editProjectPhoto editProjectVideo editProjectVideoProcessed" key={media.id}
                   data-media-selected={!!this.state.selectedMedia[media.id]}>
                  {this.selectionCheckbox(media)}
                <InView as="div" onChange={(inView) => this.changeVideoState(inView)}>
                  <video controls muted playsInline ref={this.videoRef} preload="metadata" id={this.state.photoSelection ? "disabledVideo" : ""}>
                    {/* Optimization job is disabled — always serve the original. If it's
                        ever turned back on, restore: media.optimized_video_url || media.url */}
                    <source src={media.url} type="video/mp4" />
                  </video>
                </InView>
                <div className="filename">{stripFileExtension(media.file_name)}</div>
                <div className="textUnderVideo">
                  {/* <div><a className="small" href={media.url}>Download</a></div> */}

                  <div className="embedededCodeDiv">
                    <div className="videoEmbeddedClipboard" onClick={() => this.copyMLSCode(media.id, project?.slug)}>Copy MLS URL</div>
                  </div>
                  {this.state.copied[media.url] && <div className="textCopiedText small">Code copied!</div>}
                </div>
              </div>
            )
          })}
        </>
      }
    } else if (selectedService?.media_types === "matterport" && this.props.project?.external_model_id) {

      let iframeCode = `<iframe width = '853' height = '480' frameborder = '0' allowfullscreen allow = 'xr-spatial-tracking' src="${this.props.project?.external_model_id}"/>`
      projectEditUl = <div className="matterportProjectPageContainer">
        <div className="matterportEditOption matterportEditOptionMain">
          <div className="inputGroup matterportInputGroup">
            <label className="matterportLabel">Interactive Tour Code Snippet</label>
            <textarea className="formTextArea" disabled="true" value={iframeCode} />
          </div>
          <div className="projectEditButton projectEditButtonPrimary matterportButton" onClick={() => this.copySnippet(iframeCode)}>Copy Snippet</div>
          {this.state.copiedSnippet && <div className="matterportCopiedText small">Code copied!</div>}
        </div>
        <div className="matterportEditOption matterportEditOptionMain">
          <div className="inputGroup matterportInputGroup">
            <label className="matterportLabel">Preview Link</label>
            <input className="formInput matterportDesignDiv" disabled="true" value={this.props.project?.external_model_id} />
          </div>
          <div className="projectEditButton projectEditButtonPrimary matterportButton" onClick={() => this.copyLink(this.props.project?.external_model_id)}>Copy Link</div>
          {this.state.copiedLink && <div className="matterportCopiedText small">Code copied!</div>}
        </div>
        <iframe className="video-project-edit" src={this.props.project?.external_model_id}/>
      </div>
    }

    const tourLinkPresent = selectedService?.media_types === 'matterport' && !!project?.external_model_id
    if (selectedService && !this.state.loading && medias.length === 0 && photos === 0 && !tourLinkPresent) {
      const mediaName = {
        'Photography': 'photos',
        'Drone': 'drone media',
        'Video': 'videos',
        'Twilight': 'twilight photos',
        'Floor Plans': 'floor plans',
        'Virtual Staging': 'virtual edits'
      }[selectedService.title] || selectedService.title.toLowerCase()
      const isTour = selectedService.media_types === 'matterport'
      projectEditPhotosUlId = "projectEditPhotosUlEmpty"
      projectEditUl = <div className="projectMediaWaiting" role="status">
        <strong>{isTour ? `Waiting for the ${selectedService.title} link` : `Waiting for ${unprocessed ? 'unprocessed' : 'processed'} ${mediaName}`}</strong>
        <p>{isTour ? 'Your tour will appear here once its link is added.' : unprocessed ? `Uploaded ${mediaName} will appear here.` : `Completed ${mediaName} will appear here once delivered.`}</p>
        {canUpload && selectedService.title === 'Virtual Staging' && <button className="projectEditButton projectEditButtonPrimary m-auto mt-2"
                              onClick={this.openUploadModal}>
            Upload media
          </button>}
      </div>
    }

    if (this.state.modalOpen) {
      modal = <UploadPhotosModal submitPhotosFromUploadModal={this.submitPhotosFromUploadModal}
                                 submitMatterport={(link) => this.submitMatterportFromUploadModal(link)}
                                 current_service={selectedService}
                                 project={this.props.project}
                                 unprocessed={this.state.unprocessed}
                                 onClose={() => this.setState({modalOpen: false})}
                                 isLargeScreen={this.props.isLargeScreen}/>
    }

    if (this.state.galleryModal) {
      modal = <GalleryModal photos={medias} changeParentState={this.handler} current_service={selectedService}
                            currentPhoto={this.state.currentPhoto}/>
    } else if (this.state.downloadModal){
      modal = <DownloadModal project={this.props.project} current_service={selectedService} onClose={this.onClose}/>
    } else if (this.state.virtualStagingGalleryModal){
      modal = <GalleryModal photos={[this.state.virtualStagingPhoto]} changeParentState={this.handler} currentPhoto={0} onClose={() => this.setState({virtualStagingGalleryModal: false})}/>
    } else if (this.state.shareMediaModal){
      modal = <ShareMediaModal project={this.props.project} changeParentState={this.handler} />
    } else if (this.state.floorPlanLabelsModal){
      modal = <FloorPlanLabelsModal project={this.props.project} data={this.state.floorPlanLabelsData}
                                    onClose={() => this.setState({floorPlanLabelsModal: false})}
                                    onSaved={() => this.watchFloorPlanZip(selectedServiceId)}/>
    }

    const downArrow = (medias.length > this.state.streamAmount) && this.state.unprocessed && selectedService?.title != "Virtual Staging" ? (
      <div className="editPhotosDownArrow"
           onClick={() => this.setState({streamAmount: this.state.streamAmount + 12})}>
        <img src={arrowDownSrc}/>
      </div>) : <></>

    let matterportAdminOption = ""

    if (selectedService?.media_types === "matterport" && (currentUser?.roles?.admin || currentUser?.roles?.contractor || currentUser?.roles?.post_production || (project?.upload_key && this.props.match.params.accessCode === project?.upload_key))){
      matterportAdminOption =
      <div className="matterportEditOption">
      <div className="inputGroup matterportInputGroup matterportInputGroupSpecial">
        <label className="matterportLabel">Upload Link</label>
        <input className="formInput matterportDesignDiv" placeholder="Upload Link" disabled={this.state.uploadDisabled} onChange={this.onInputChange('upload_link')}
            value={this.state.upload_link} />
       </div>
          {this.state.uploadDisabled ? <div className="projectEditButton projectEditButtonPrimary matterportButton" onClick={() => this.setState({ uploadDisabled: false })}>Edit</div> : <div className="projectEditButton projectEditButtonPrimary matterportButton" onClick={this.submitMatterport}>Submit</div>}
      </div>
    }


    if (this.state.loading) projectEditUl = <AppLoading label="Loading media…" variant="media"/>
    if (this.state.loadError) projectEditUl = <AppLoadError label="We couldn’t load this media." retry={() => this.reloadProjectMedias(services[this.state.selectedServiceIndex]?.id)}/>

    return (
      <div>
        {modal}
        <div className="editProjectPhotosServices">
          {services.map((service, i) => {
            const ServiceIcon = serviceIcon(service.slug)
            const active_package = Object.values(project?.packages || []).find(current_package => current_package.service_id === service.id)
            return <div
              className={`editProjectPhotosService ${selectedServiceIndex === i ? 'selected' : ''} ${selectedServiceIndex === i + 1 ? 'prev-selected' : ''}`}
              onClick={e => this.selectService(e, i)}
              key={`service-${i}`}>
              {this.props.isLargeScreen ? <div>{service.title}</div> : <div><ServiceIcon className="editProjectMediaServiceIcon" /></div>}
            </div>
          })}
          <div className="editProjectPhotosService">
            <div/>
          </div>
        </div>
        {this.state.loading ? <div className="editProjectPhotosSectionInner"><AppLoading label="Loading media…" variant="media"/></div>
          : this.state.loadError ? <div className="editProjectPhotosSectionInner"><AppLoadError label="We couldn’t load this media." retry={() => this.reloadProjectMedias(services[this.state.selectedServiceIndex]?.id)}/></div>
          : <div className="editProjectPhotosSectionInner">
          <div className="d-flex justify-content-between flex-wrap buttonProjectEditGroup">
            <div className="d-flex align-items-center buttonProjectEditGroup">
              {matterportAdminOption}
              {selectedService?.media_types != "matterport" &&
                <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary downloadAllButton" id={(medias.length === 0 && photos === 0) || (this.state.unprocessed && !this.state.unprocessed_zip_worker_file) || !this.state.unprocessed && !this.state.processed_zip_worker_file ? "disabledButton" : ""} onClick={e => (medias.length === 0 && photos === 0) || (this.state.unprocessed && !this.state.unprocessed_zip_worker_file) || !this.state.unprocessed && !this.state.processed_zip_worker_file ? "" : this.downloadAll(e, medias)}>
                <img src={mediaDownloadIconSrc} className="me-2"/>
                  {this.state.floorPlanZipPending && selectedService?.title === "Floor Plans" ? "Preparing download…" : <>Download {selectedService?.title}</>} {!this.state.floorPlanZipPending && isAdmin && selectedService?.media_types === "image" ? photos > 0 ? `(${photos})`: `(${medias.length})` : ""}
              </button>}
              {canUpload && selectedService && selectedService?.media_types != "matterport" && !(selectedService?.title === "Floor Plans" && this.state.manualUpload === false && this.state.unprocessed) ? <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary projectEditButtonUpload downloadAllButton" onClick = { this.openUploadModal }>
                Upload
              </button> : ""}
              {canUpload && !currentUser?.roles?.contractor && selectedService?.title === "Floor Plans" && this.state.manualUpload === false && this.state.unprocessed ? <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary projectEditButtonUpload" onClick={() => this.setState({manualUpload: true})}>
                Enable Manual Upload
              </button> : ""}

            {/* {(isClient || isAdmin || isClientsBroker) && currentUser && !this.state.unprocessed && !this.props.currentUser?.roles?.post_production && <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary downloadAllButton projectEditButtonUpload" onClick={() => this.copySnippet(`${window.location.origin}/projects_index/${this.props.project.slug}/share/${this.props.project.download_key}`)}>
              Share Media
            </button>} */}

              {!this.props.listingToolsVisible && (isClient || isAdmin || isClientsBroker) && currentUser && selectedService?.media_types != "matterport" && !this.state.unprocessed && !this.props.currentUser?.roles?.post_production && <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary downloadAllButton projectEditButtonUpload" onClick={() => this.setState({shareMediaModal: true})}>
              Share Media
            </button>}

            {(isClient || isAdmin || isClientsBroker) && currentUser && selectedService?.title === "Floor Plans" && this.state.floorPlanLabelsEditable && !this.state.unprocessed && medias.length > 0 && <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary downloadAllButton projectEditButtonUpload" disabled={this.state.floorPlanLabelsLoading} onClick={this.openFloorPlanLabels}>
              {this.state.floorPlanLabelsLoading ? "Loading…" : "Edit Room Names"}
            </button>}

            {!this.props.listingToolsVisible && isAdmin && currentUser && selectedService?.media_types != "matterport" && <button className="projectEditButton projectEditMarginBottomButton projectEditButtonPrimary downloadAllButton projectEditButtonUpload" onClick={() => this.copySnippet(`${window.location.origin}/projects_index/${this.props.project?.slug}/access/${this.props.project?.upload_key}`)}>
              Share Access
            </button>}
            </div>

             {canUpload && currentUser?.roles?.admin && selectedService?.title === "Floor Plans" && this.state.unprocessed &&
              <div className="projectEditButton projectEditMarginBottomButton projectEditButtonUpload projectEditButtonPrimary downloadAllButton" id={selected_package.cubicasa ? "greenButton" : "redButton"}>
                {selected_package.cubicasa ? "CubiCasa Active" : "CubiCasa Inactive"}
              </div>}

            {isAdmin && selectedService?.media_types != "matterport" && <div className="d-flex flex-column">
              {selected_package && this.state.unprocessed &&
                <div className="saveMediaMobileRow">
                  {(() => {
                    const sm = this.state.saveMediaPending[selected_package.id] !== undefined ? this.state.saveMediaPending[selected_package.id] : selected_package.save_media
                    return (
                      <button
                        onClick={() => this.swapSaveMedia(selected_package.id, !sm)}
                        className={`w-100 projectEditButton projectEditMarginBottomButton ${sm ? '' : 'projectEditButtonLight'}`}
                        id={sm ? "greenButton" : ""}
                        style={{whiteSpace: 'nowrap', cursor: 'pointer'}}>
                        {sm ? "Save Media On" : "Save Media Off"}
                      </button>
                    )
                  })()}
                </div>}

              <div className="d-flex justify-content-end">
                {selected_package && this.state.unprocessed &&
                  (() => {
                    const sm = this.state.saveMediaPending[selected_package.id] !== undefined ? this.state.saveMediaPending[selected_package.id] : selected_package.save_media
                    return (
                      <button
                        onClick={() => this.swapSaveMedia(selected_package.id, !sm)}
                        className={`saveMediaDesktopBtn projectEditButton projectEditMarginBottomButton ${sm ? '' : 'projectEditButtonLight'}`}
                        id={sm ? "greenButton" : ""}
                        style={{whiteSpace: 'nowrap', marginRight: '10px', alignSelf: 'stretch', cursor: 'pointer'}}>
                        {sm ? "Save Media On" : "Save Media Off"}
                      </button>
                    )
                  })()}

                <button onClick={() => this.setState({ unprocessed: true, selectedMedia: {}, photoSelection: false})}
                  className={`projectEditButton projectEditMarginBottomButton projectEditUnprocessedButton ${unprocessed ? 'projectEditButtonPrimary' : 'projectEditButtonLight'}`}>
                  Unprocessed
                </button>

                <button onClick={() => this.setState({unprocessed: false, selectedMedia: {}, photoSelection: false})}
                  className={`projectEditButton projectEditMarginBottomButton projectEditProcessedButton ${unprocessed ? 'projectEditButtonLight' : 'projectEditButtonPrimary'}`}>
                  Processed
                </button>
              </div>
            </div>}
          </div>

          <div className="divider"/>

          {selectionButtons}

          <div className={`editProjectPhotos ${this.state.photoSelection ? "mediaSelectionActive" : ""}`} id={projectEditPhotosUlId}>
            {projectEditUl}
          </div>
          <div>
            {downArrow}
          </div>
        </div>}
      </div>
    )
  }
}

export default withRouter(EditProjectMedia);
